const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const getCachedScript = require('lib/get_cached_script')
const g = require('globals')
const config = require('lib/config')
const radio = require('lib/radio')
const Raven = require('lib/raven')

const channel = radio.auth

const log = require('log').create('auth', 'google') // eslint-disable-line

const google_url = 'https://accounts.google.com/gsi/client'


const Controller = Marionette.MnObject.extend({

    initialize(options) {

        _.bindAll(this, 'googleLoaded', 'googleFailed')

        this.button_container = options.element[0]

        getCachedScript(google_url).done(this.googleLoaded).fail(this.googleFailed)
    },

    googleLoaded() {

        try {
            window.google.accounts.id.initialize({
                client_id: config.get('social.google.client_id'),
                callback: this.signUpWithGoogle,
                use_fedcm_for_prompt: true,
            })
            const options = {
                theme: 'outline',
                logo_alignment: 'left',
                text: 'signin_with',
                size: 'medium',
                width: 205,
            }
            window.google.accounts.id.renderButton(this.button_container, options)
            channel.trigger('google:initialized')
        } catch (e) {
            Raven.captureException(e)
            channel.trigger('google:failed')
        }
    },

    googleFailed() {
        channel.trigger('google:failed')
    },

    signUpWithGoogle(googleUser) {
        // Get the id token to sign them up with & the necessary user info.
        let input

        try {
            input = { id_token: googleUser.credential }
        } catch {
            channel.trigger('google:auth:fail', {
                message: 'Google user not found. Please try again.',
            })
        }

        $.ajax({
            type: 'POST',
            url: `${g.NODE_API}/social/google`,
            data: input,
        })
            .done((output) => {
                channel.trigger('google:auth:success', {
                    output,
                })
            })
            .fail((output) => {
                channel.trigger('google:auth:fail', {
                    message: 'We were unable to process your signup through Google. Please try another method.',
                })
            })

    },
})

module.exports = Controller
